import { Injectable } from '@angular/core';

import { ActivityRoutineModel } from '../../models/models';

@Injectable()
export class ActivityRoutineProvider {

  constructor() {
  }

  Load() {
    return new Promise((resolve, reject) => {
      let items: ActivityRoutineModel[] = [];
      items.push({
        _id: 1,
        Name: 'Shoulders',
        Notes: 'Do this on Monday',
        ActivityItems: [{
          _id: 1,
          Name: 'Side Lat Raise',
          SortOrder: 1
        },
        {
          _id: 2,
          Name: 'Military Barbell Press',
          SortOrder: 2
        }]
      } as ActivityRoutineModel);
      items.push({
        _id: 2,
        Name: 'Back',
        Notes: 'Do this on Wednesday',
        ActivityItems: [{
          _id: 3,
          Name: 'Pullups',
          SortOrder: 1
        },
        {
          _id: 4,
          Name: 'Bent Barbell Row',
          SortOrder: 2
        }]
      } as ActivityRoutineModel);

      this.Sort(items);

      resolve(items);
    });
  }

  Sort(items) {
    items.sort((a: ActivityRoutineModel, b: ActivityRoutineModel) => {
      if (a.Name.toLowerCase() > b.Name.toLowerCase()) return 1;
      else if (a.Name.toLowerCase() < b.Name.toLowerCase()) return -1;
      else return 0;
    });
    return items;
  }
}


// WEBPACK FOOTER //
// ./src/providers/activity-routine/activity-routine.ts